<mat-card appearance="outlined" class="mat-elevation-z1 mat-card-scrollable">
    <mat-card-header>
        <mat-card-title>
            {{ 'VirtualDesk.Title' | translate }}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        @if (isSent === false) {
            <mat-form-field class="text">
                <mat-label>{{ 'VirtualDesk.Text' | translate }}</mat-label>
                <textarea matInput [formControl]="formGroup.controls['text'] | formControl"></textarea>
            </mat-form-field>
            <mat-form-field class="name">
                <mat-label>{{ 'VirtualDesk.Name' | translate }}</mat-label>
                <input matInput required [formControl]="formGroup.controls['name'] | formControl" />
                <mat-error>
                    <sl-form-field-error-control [control]="formGroup.controls['name']" />
                </mat-error>
            </mat-form-field>
            <mat-form-field class="phone">
                <mat-label>{{ 'VirtualDesk.Phone' | translate }}</mat-label>
                <input matInput required [formControl]="formGroup.controls['phone'] | formControl" />
                <mat-error>
                    <sl-form-field-error-control [control]="formGroup.controls['phone']" />
                </mat-error>
            </mat-form-field>
            <mat-form-field class="email">
                <mat-label>{{ 'VirtualDesk.Email' | translate }}</mat-label>
                <input type="email" matInput required email [formControl]="formGroup.controls['email'] | formControl" />
                <mat-error>
                    <sl-form-field-error-control [control]="formGroup.controls['email']" />
                </mat-error>
            </mat-form-field>
        } @else {
            {{ 'VirtualDesk.MessageSent' | translate }}
        }
    </mat-card-content>
    @if (isSent === false) {
        <mat-card-actions>
            <button mat-button (click)="submit()">
                <mat-icon>send</mat-icon>
                {{ 'VirtualDesk.Send' | translate }}
            </button>
        </mat-card-actions>
    }
</mat-card>
